import { render } from "./ExpiredImplants.vue?vue&type=template&id=6d689e0a&scoped=true"
import script from "./ExpiredImplants.vue?vue&type=script&lang=js"
export * from "./ExpiredImplants.vue?vue&type=script&lang=js"

import "./ExpiredImplants.vue?vue&type=style&index=0&id=6d689e0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d689e0a"]])

export default __exports__